export const environment = {
    mobile: false,
    mobileScreenSize: 600,
    pdfDownloadEnabled: false
};
